// extracted by mini-css-extract-plugin
export default {"uploadInput":"styles_uploadInput__bI+Hn","link":"styles_link__KS0Wo"};